/**
 * Simple AbortController Manager
 * Easy to understand logic for canceling API calls when user logs out
 */

// Simple array to store all active abort controllers
let activeControllers: AbortController[] = []

/**
 * Add a new abort controller to the list
 * @param controller - The AbortController to track
 */
export const addController = (controller: AbortController) => {
  activeControllers.push(controller)

  // Auto-cleanup: Remove controller when it's aborted
  controller.signal.addEventListener('abort', () => {
    removeController(controller)
  })
}

/**
 * Remove an abort controller from the list (when request completes)
 * @param controller - The AbortController to remove
 */
export const removeController = (controller: AbortController) => {
  const index = activeControllers.indexOf(controller)
  if (index > -1) {
    activeControllers.splice(index, 1)
  }
}

/**
 * Cancel all active API calls
 * This is called when user logs out
 */
export const cancelAllRequests = () => {
  // Cancel all active requests
  activeControllers.forEach((controller) => {
    controller.abort()
  })

  // Clear the array
  activeControllers = []
}

/**
 * Get the number of active requests (for debugging)
 */
export const getActiveRequestCount = () => {
  return activeControllers.length
}
